import { useWeb3React } from '@web3-react/core';
import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';

const useUserStatistics = () => {
    const { account } = useWeb3React();

    const { sdk } = useContext(appContext);

    const { data, error } = useSWR(
        sdk && account ? ['userStatistics', account] : null,
        (_, userAddress) => sdk!.spools.getUserStatistics(userAddress!)
    );

    return {
        userStatistics: data,
        isLoading: !error && !data,
        error,
    };
};

export default useUserStatistics;
